let _ = t => t,
  _t;
import styled from 'styled-components';
export const ChildrenWrapper = styled.div(_t || (_t = _`
    overflow: hidden;

    transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`));